<div [ngStyle]="fillParent ? {'width': '100%', 'height': '100%'} : {'width': width + 'px', 'height': height + 'px'}" style="position: relative; display: block;">
  <canvas baseChart
    [data]="chartData"
    [options]="chartOptions"
    [type]="type">
  </canvas>
</div>